import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Header from "../../../SharedFiles/Header/Header";
import Footer from "../../../SharedFiles/Footer/Footer";
import { useDispatch, useSelector } from "react-redux";
import { GetGrpoData } from "../../../APIServices/ProductionService/GRPOServices/grpoThunk";
import './Dashboard.css';
import { GetDisassembleInput } from "../../../APIServices/ProductionService/DisassembleService/DisassembleThunk";
import { GetItemTemp } from "../../../APIServices/ProductionService/InventoryPosting/inventoryPostingThunk";
import toast, { Toaster } from "react-hot-toast";
import { HashLoader } from "react-spinners";
import { selectLoaderState } from "../../../APIServices/LoaderSlice";
import { GetItem } from "../../../APIServices/ProductionService/DeliveryService/DeliveryServiceThunk";
import '../../../SharedFiles/CommonFile/Style.css';
import { useTranslation } from 'react-i18next'; 
import { GetQrData } from "../../../APIServices/ProductionService/BackupQRcode/backupGenerateQrThunk";
import { GetReturn } from "../../../APIServices/ProductionService/Return/returnThunk";

const DashBoard = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const loaderState = useSelector(selectLoaderState);
  const [callInProgress, setCallInProgress] = useState(
    { INVPosting: false, Disassemble: false })
  const { GetDetailsItem, loading, error } = useSelector(
    (state) => state.InvPosting || {}
  );
  const { DisassembleData } = useSelector((state) => state.Disassemble);
  const isLoading = () => {
    return loaderState.loadingActions['GetDetailsItem'] ||
      loaderState.loadingActions['DisassembleData'];
  };
  const errorMessage = (action) => loaderState.errorMessages[action];

  const batchChecker = () => {
    if (callInProgress.INVPosting && errorMessage('GetDetailsItem')) {
      const errorss = errorMessage('GetDetailsItem');
      setCallInProgress({ ...callInProgress, INVPosting: false });
      const status = errorss.errorCode;
      const errormessages = errorss.errorMessage;
      if (status) {
        toast.error(errormessages);
      } else {
        toast.error(t('Network error'));
      }
    } else if (callInProgress.INVPosting && GetDetailsItem && !loading.GetDetailsItem) {
      setCallInProgress({ ...callInProgress, INVPosting: false });
      navigate("/production/InventoryPosting");
    }
    if (callInProgress.Disassemble && errorMessage('DisassembleData')) {
      const errorss = errorMessage('DisassembleData');
      setCallInProgress({ ...callInProgress, Disassemble: false });
      const status = errorss.errorCode;
      const errormessages = errorss.errorMessage;
      if (status) {
        toast.error(errormessages);
      } else {
        toast.error(t('Network error'));
      }
    } else if (callInProgress.Disassemble && DisassembleData && !loading.GetDetailsItem) {
      setCallInProgress({ ...callInProgress, Disassemble: false });
      navigate("/production/Disassemble");
    }
  };
  
  useEffect(() => {
    batchChecker();
  }, [GetDetailsItem, loading, error, callInProgress]);
  const handleNavGrpoPage = () => {
    navigate("/production/Grpo");
  };
  const handleNavGrpoPage2 = () => {
    dispatch(GetGrpoData());
    navigate("/production/GRPOMain");
  };
  const handleITpage = () => {
    navigate("/production/ITMain");
  };
  // const handlePaymentCollection = () => {
  //   navigate("/PaymentCollection");
  // };
  const handleInventoryPosting = () => {
    dispatch(GetItemTemp());
    setCallInProgress({ ...callInProgress, INVPosting: true });
    // navigate("/production/InventoryPosting");
  };
  const handledelivery = () => {
     dispatch(GetItem())
    navigate("/production/Delivery");
  };
  const handleSliting = async () => {
    await dispatch(GetDisassembleInput());
    setCallInProgress({ ...callInProgress, Disassemble: true });
    // navigate("/Disassemble");
  };
  const handleProductionFg = () => {
    navigate("/production/ProductionFg");
  };

  const handleNavQRGenerate=async()=>{
    await dispatch(GetQrData({searchvalue:''}))
    navigate("/production/generateQr");
  }


  const handleReturn = async()=>{
    // await dispatch(GetReturn());
    navigate("/production/Return")
  }
  return (
    <>
      {/* <Header /> */}
      <div className="dashboard-container d-flex justify-content-center align-items-center flex-wrap" style={{ minHeight: '86vh' }}>
        <div className="text-center col-12 col-md-3 mb-3">
          <button
            onClick={handleNavGrpoPage2}
            type="button"
            className="btn dashboard-button mb-3">
            {t('GRPO')}
          </button>
          <button
            onClick={handleInventoryPosting}
            type="button"
            className="btn dashboard-button mb-3">
            {t('INVENTORY POSTING')}
          </button>
          <button
            onClick={handleSliting}
            type="button"
            className="btn dashboard-button mb-3">
            {t('SLITTING')}
          </button>
          <button
            onClick={handleProductionFg}
            type="button"
            className="btn dashboard-button mb-3">
            {t('PRODUCTION FG')}
          </button>
          <button
            onClick={handledelivery}
            type="button"
            className="btn dashboard-button mb-3">
            {t('DELIVERY')}
          </button>
          <button
            onClick={handleReturn}
            type="button"
            className="btn dashboard-button mb-3">
            {t('RETURN')}
          </button>
          <button
            onClick={handleITpage}
            type="button"
            className="btn dashboard-button mb-3">
            {t('INVENTORY TRANSFER')}
          </button>
          <button
            onClick={handleNavQRGenerate}
            type="button"
            className="btn dashboard-button mb-3">
            {'GENERATE QRCODE'}
          </button>
        
          
        
        
          
        </div>
      </div>
      <Toaster
        position="top-center"
        toastOptions={{
          style: { fontSize: '16px', padding: '16px', width: '400px', borderRadius: '8px' },
        }} />
      {isLoading() && (
        <div className="loader">
          <HashLoader color="#ed1c24" />
        </div>
      )}
      <Footer />
    </>
  );
};

export default DashBoard;
